import {
  FETCH_PAGE_END,
  FETCH_PAGE_ERROR,
  FETCH_PAGE_START,
  PREVIOUS_ROUTE,
} from '../actions/page';
import { SET_STATUS_CODE } from '../actions/status';

const initialState = {
  isLoadingData: false,
  statusCode: '',
  pageData: {
    subject: {
      content: {
        id: '',
        title: '',
        theme: {},
        mapsKey: 'AIzaSyAkyD6sABjJMMLCgYh1wppv2KYttt7hCWw',
        ga: {
          gtm: '',
          dataLayer: {
            siteType: '',
          },
        },
      },
      regions: [],
      template: {
        content: {},
        extendedProperties: {},
      },
      extendedProperties: {},
    },
    context: {
      content: {
        hostMapping: {
          default: '',
          hostname: '',
          path: '',
          pathPostfix: '',
          countryCode: '',
          languageCode: '',
          siteId: '',
          zone: '',
        },
        partner: 'simonhenning',
        siteId: '',
        'api-version': '',
      },
      globalization: {
        country: '',
        language: '',
        locale: '',
      },
      request: {
        uri: '',
        scheme: '',
        queryString: '',
        routeData: {},
      },
      correlationId: '',
    },
  },
};

export default (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case FETCH_PAGE_START:
      return {
        ...state,
        isLoadingData: true,
      };
    case SET_STATUS_CODE:
      return {
        ...state,
        statusCode: action.status,
      };
    case FETCH_PAGE_END:
      return {
        ...state,
        pageData: action.payload,
        isLoadingData: false,
      };
    case FETCH_PAGE_ERROR:
      return {
        ...state,
        isLoadingData: false,
      };
    case PREVIOUS_ROUTE:
      return {
        ...state,
        prevRoute: action.payload,
      };
    /* istanbul ignore next -- @preserve */
    default:
      return state;
  }
};
